<script setup>
import PlaylistsGridTile from '@components/playlists/playlists-grid-tile'

defineProps({
    playlists: {
        type: Array,
        default: () => [],
    },
    minTileWidth: {
        type: String,
        default: '220px',
    },
    showMoreLink: {
        type: String,
        default: '',
    },
    type: {
        type: String,
        default: 'playlists',
    },
})
</script>

<template>
    <div
        class="playlists-grid-block"
        :style="{ gridTemplateColumns: `repeat(auto-fill, minmax(${minTileWidth}, 1fr))` }"
    >
        <div
            v-for="(playlist, index) in playlists"
            :key="playlist.id"
            class="tile"
        >
            <PlaylistsGridTile
                :playlist="playlist"
                :index="index"
                :type="type"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.playlists-grid-block {
    display: grid;
    gap: $size-large-grid-padding;
}

.tile {
    margin-bottom: $size-grid-padding * 2;
}
</style>
